import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GLOBAL } from './global';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PerfilService {

  headers: {
    Accept: string; "Content-Type": string; //,
  };

  constructor(
    private http: HttpClient
  ) {
    this.headers = {
      "Accept": "application/json",
      "Content-Type": "application/json"
    };
  }

  getUserPerfil(user_id: any): Observable<any> {
    return this.http.get(GLOBAL.urlApi + 'perfil/'+user_id, { headers: new HttpHeaders(this.headers) });
  }

  getNumUserSeguidores(user_id: any): Observable<any> {
    return this.http.post(GLOBAL.urlApi + 'perfil/' + user_id + '/numSeguidores', { headers: new HttpHeaders(this.headers) });
  }

  getNumUserSiguiendo(user_id: any): Observable<any> {
    return this.http.post(GLOBAL.urlApi + 'perfil/' + user_id + '/numSiguiendo', { headers: new HttpHeaders(this.headers) });
  }

  getNumPublicaciones(user_id: any): Observable<any> {
    return this.http.post(GLOBAL.urlApi + 'perfil/' + user_id + '/numPublicaciones', { headers: new HttpHeaders(this.headers) });
  }

  getPublicaciones(user_id: any): Observable<any> {
    return this.http.post(GLOBAL.urlApi + 'perfil/' + user_id + '/totalPublicaciones', { headers: new HttpHeaders(this.headers) });
  }

  getFavoritos(user_id: any): Observable<any> {
    return this.http.post(GLOBAL.urlApi + 'perfil/' + user_id + '/totalFavoritos', { headers: new HttpHeaders(this.headers) });
  }

  getProductosFav(data: any): Observable<any> {
    return this.http.post(GLOBAL.urlApi + 'perfil/' + 'productosFavoritos', data, { headers: new HttpHeaders(this.headers) });
  }

  getPlatosFav(data: any): Observable<any> {
    return this.http.post(GLOBAL.urlApi + 'perfil/' + 'platosFavoritos', data, { headers: new HttpHeaders(this.headers) });
  }

  getRestaurantesFav(data: any): Observable<any> {
    return this.http.post(GLOBAL.urlApi + 'perfil/' + 'restaurantesFavoritos', data, { headers: new HttpHeaders(this.headers) });
  }

  getUsuariosFav(data: any): Observable<any> {
    return this.http.post(GLOBAL.urlApi + 'perfil/' + 'usuariosFavoritos', data, { headers: new HttpHeaders(this.headers) });
  }

  getRolUser(user_id: any): Observable<any> {
    return this.http.post(GLOBAL.urlApi + 'perfil/' + user_id + '/rolUser', { headers: new HttpHeaders(this.headers) });
  }

  uploadImageUser(user_id:number,base64:string): Observable<any> {
    const json = JSON.stringify({user_id:user_id,base64:base64});
    const params = json;
    return this.http.post(GLOBAL.urlApi + 'perfil/image', params, { headers:new HttpHeaders(this.headers)  });
  }

  editarPerfil(params){
    return this.http.post(GLOBAL.urlApi + 'perfil/save', params, { headers: new HttpHeaders(this.headers) });
  }

  createPage(params){
    return this.http.post(GLOBAL.urlApi + 'perfil/createPage', params, { headers: new HttpHeaders(this.headers) });
  }

  deleteUser(user_id: any): Observable<any> {
    return this.http.post(GLOBAL.urlApi + 'perfil/' + user_id + '/deleteUser', { headers: new HttpHeaders(this.headers) });
  }

  getPedidos(user_id: any, page: number): Observable<any> {

    if(page == 1){
      return this.http.post(GLOBAL.urlApi + 'perfil/' + user_id + '/pedidos', { headers: new HttpHeaders(this.headers) });
    }else{
      return this.http.post(GLOBAL.urlApi + 'perfil/' + user_id + '/pedidos?page=' + page, { headers: new HttpHeaders(this.headers) });
    }

  }
}
